export default "__VITE_ASSET__0e484556__"